import { Paginated } from 'models/Paginated';

// A By Payer row: a payer at least one of the user's facilities still has. `id` is the payer's.
export type PayerNetworkSummary = {
  id: string;
  name: string;
  groupCount: number;
  updatedAt: string;
  updatedByName: string | null;
};

// A By Facility row: one of the user's allowed SNFs, including those with no payers. `id` is the group's.
export type FacilityNetworkSummary = {
  id: string;
  name: string;
  payerCount: number;
  updatedAt: string | null;
  updatedByName: string | null;
  // Only when the request named a payer: whether this facility already has it.
  added?: boolean;
};

// Not set is null, never a stored value.
export type NetworkStatus = 'in' | 'out' | null;

export type StatusField = 'commercial' | 'managedMedicare' | 'managedMedicaid' | 'other';

export type BulkPayerType = 'all' | 'commercial' | 'managed_medicare' | 'managed_medicaid' | 'other';

// `payerType` is the bulk PATCH's value, which OliveBranch leaves as sent, so it stays snake_case.
export const PAYER_TYPES: { field: StatusField; payerType: Exclude<BulkPayerType, 'all'>; label: string }[] = [
  { field: 'commercial', payerType: 'commercial', label: 'Commercial' },
  { field: 'managedMedicare', payerType: 'managed_medicare', label: 'Managed Medicare' },
  { field: 'managedMedicaid', payerType: 'managed_medicaid', label: 'Managed Medicaid' },
  { field: 'other', payerType: 'other', label: 'Other' },
];

// One facility added to one payer, with its status for each payer type.
export type GroupPayerNetworkStatus = Record<StatusField, NetworkStatus> & {
  id: string;
  groupId: string;
  groupName: string;
  stediPayerId: string;
  stediPayerName: string;
};

type Named = { id: string; name: string };

// The page's subject comes back beside its rows, so a facility with no payers still has a title.
export type GroupPayerNetworkStatusIndex = Paginated<GroupPayerNetworkStatus> & { group?: Named; stediPayer?: Named };

// An Admin > Payer Network Status row: a client and its most recent change, null when it has none.
export type NetworkStatusClientSummary = {
  id: string;
  name: string;
  updatedAt: string | null;
  updatedByName: string | null;
};
